import { render } from "./MasterDataManagement.vue?vue&type=template&id=75cd9cf6&scoped=true"
import script from "./MasterDataManagement.vue?vue&type=script&lang=js"
export * from "./MasterDataManagement.vue?vue&type=script&lang=js"

import "./MasterDataManagement.vue?vue&type=style&index=0&id=75cd9cf6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75cd9cf6"]])

export default __exports__